import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IDeleteUserRemoteAgentsParams {
  ownerId: string;
  deviceIds: string[];
}

export class DeleteUserRemoteAgentsRequest extends Request<IDeleteUserRemoteAgentsParams, IResult> {
  constructor(params: IDeleteUserRemoteAgentsParams) {
    super('deleteUserRemoteAgents', params);
  }
}
